import React from 'react';
import OfferOrder from './components/OfferOrder';
// import CustomTabs from 'components/CustomTabs';
// import { TabContent, TabPane } from 'reactstrap';
// import { OFFER_AND_DEMAND } from 'helper/constants';
// import DemandOrder from './components/DemandOrder';

const Ordered = ({ show, setShow }) => {
  // const [activeTab, setActiveTab] = useState(OFFER_AND_DEMAND.OFFERS);

  // const toggle = (tab) => {
  //   if (activeTab !== tab) setActiveTab(tab);
  // };

  return (
    <>
      <OfferOrder setShow={setShow} show={show} />
      {/* <div className="d-flex align-items-center">
        <CustomTabs
          tabs={['Offers', 'Demands']}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="toggle-tab mb-1 d-inline-flex w-auto"
        />
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={OFFER_AND_DEMAND.OFFERS}>
          {activeTab === OFFER_AND_DEMAND.OFFERS && <OfferOrder />}
        </TabPane>
        <TabPane tabId={OFFER_AND_DEMAND.DEMANDS}>
          {activeTab === OFFER_AND_DEMAND.DEMANDS && <DemandOrder />}
        </TabPane>
      </TabContent> */}
    </>
  );
};

export default Ordered;
